// Re-exports the shared ChangePasswordDialog in admin mode.
// Supports both onSuccess and legacy ClosePopUp callback props.
import SharedDialog from '@/components/ui/change-password-dialog';

function ChangePass({ open, onOpenChange, onSuccess, ClosePopUp, repid }) {
    const handleSuccess = () => {
        if (onSuccess) onSuccess();
        else if (ClosePopUp) ClosePopUp();
    };

    const handleOpenChange = (val) => {
        if (onOpenChange) onOpenChange(val);
        else if (!val && ClosePopUp) ClosePopUp();
    };

    return (
        <SharedDialog
            open={open}
            onOpenChange={handleOpenChange}
            mode="admin"
            repid={repid}
            onSuccess={handleSuccess}
        />
    );
}

export default ChangePass;
